import React from 'react';
import { ReactComponent as FavoriteActiveIcon } from '../icons/icon_add_to_favorites_active.svg';
import { ReactComponent as FavoriteInactiveIcon } from '../icons/icon_add_to_favorites_inactive.svg';
import { ReactComponent as FavoriteActiveIconWh } from '../icons/icon_add_to_favorites_active_wh.svg';
import { ReactComponent as FavoriteInactiveIconWh } from '../icons/icon_add_to_favorites_inactive_wh.svg';
import { useFavorites, useFavoritesDispatch } from './FavoritesProvider';
import { getConfiguration } from '../data/utils/configuration';

export default function FavoriteButton(props) {
    const favorites = useFavorites();
    const dispatch = useFavoritesDispatch();
    const conf = getConfiguration();

    function handleClick(e) {
        e.stopPropagation();
        dispatch({
            type: 'toggle',
            id: props.id
        });
    }

    const active = favorites[props.id] === true;

    return (
        <div onClick={handleClick}>
            {active ? (
                conf.iwh ? <FavoriteActiveIconWh className='favoriteIcon_wh' /> : <FavoriteActiveIcon />
            ) : (
                conf.iwh ? <FavoriteInactiveIconWh className='favoriteIcon_wh' /> : <FavoriteInactiveIcon className="fill-cs8" />
            )}
        </div>
    );
}
